export const mmI18nConstants = {
    translationGroup: "_i18n"
}